<template>
  
  <rect
    class               = "selection-box"
    :style              = "style"
    :x                  = "x"
    :y                  = "y"
    :width              = "width"
    :height             = "height"
    @mousedown.prevent  = "$emit('mousedown', $event);"
  />

</template>

<script>

export default {

  // #region Properties

  props: {
    shape: Object
  },
  computed: {
    x() {
      switch (this.shape.type) {
      case 'rectangle': return this.shape.x;
      case 'ellipse': return this.shape.cx - this.shape.rx;
      case 'polygon': return this.shape.points.reduce((previous, current) => (previous.x < current.x) ? previous : current).x;
      default: return 0;
      }
    },
    y() {
      switch (this.shape.type) {
      case 'rectangle': return this.shape.y;
      case 'ellipse': return this.shape.cy - this.shape.ry;
      case 'polygon': return this.shape.points.reduce((previous, current) => (previous.y < current.y) ? previous : current).y;
      default: return 0;
      }
    },
    width() {
      switch (this.shape.type) {
      case 'rectangle': return this.shape.width;
      case 'ellipse': return this.shape.rx * 2;
      case 'polygon': return this.shape.points.reduce((previous, current) => (previous.x > current.x) ? previous : current).x - this.x;
      default: return 0;
      }
    },
    height() {
      switch (this.shape.type) {
      case 'rectangle': return this.shape.height;
      case 'ellipse': return this.shape.ry * 2;
      case 'polygon': return this.shape.points.reduce((previous, current) => (previous.y > current.y) ? previous : current).y - this.y;
      default: return 0;
      }
    },
    style() {
      return {
        'fill':             'transparent',
        'vector-effect':    'non-scaling-stroke',
        'stroke-dasharray': '6 4',
        'stroke':           'white',
        'stroke-width':     '2'
      }
    }
  }

  // #endregion Properties

}

</script>

<style scoped>

.selection-box {
  cursor: move;
}

</style>